import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Collapse
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

export const seoMeta = {
  title: 'Чаршафи с ластик памучен сатен 100% памук | Размери по поръчка | GoToBed',
  description:
    'Чаршафи с ластик от памучен сатен 100% памук. Гладка и елегантна материя, за стандартни и нестандартни матраци. Изработка по поръчка. Поръчайте от GoToBed.'
};

const seoLinkStyle = {
  color: '#F57819',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': { color: '#A34D08' }
};

export function SeoHeader() {
  const [introExpanded, setIntroExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        component="h1"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0
        }}>
        Чаршафи с ластик памучен сатен от 100% памук
      </Typography>
      <Typography variant="h6" component="p" fontWeight={600} sx={{ mb: 2 }}>
        Чаршафи с ластик от памучен сатен – 100% памук и голямо разнообразие от размери
      </Typography>
      <Box
        sx={{
          ...(!introExpanded && {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          })
        }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          В тази категория ще откриете чаршафи с ластик от памучен сатен (100% памук) в разнообразие
          от размери, подходящи за различни видове матраци. Памучният сатен е предпочитан за спално
          бельо заради фината си структура и приятното усещане при допир. Предлагаме богато
          разнообразие от размери чаршафи с ластик, за да откриете лесно подходящия вариант за вашия
          матрак. Налични са популярни размери като 80/200, 90/200, 100/200, 120/200, 140/200,
          160/200, 180/200 и 200/200, както и варианти за матраци с дължина 190–220 см и височина до
          50 см.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Можете да разгледате и:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/charshafi-s-lastik/1/3"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            всички чаршафи с ластик
          </Typography>
        </Box>
      </Box>
      <Button
        onClick={() => setIntroExpanded(!introExpanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {introExpanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
    </Box>
  );
}

export default function SeoBody() {
  return <SeoBodyFittedSheetsSaten />;
}

function SeoBodyFittedSheetsSaten() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mt: 6 }}>
      {/* H2: Чаршафи с ластик от памучен сатен */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
        Чаршафи с ластик от памучен сатен – комфорт и елегантен вид
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Чаршафите с ластик от 100% памучен сатен съчетават естествените качества на памука с
        по-гладка и фина текстура на плата. Благодарение на специалния начин на тъкане памучният
        сатен е мек, приятен на допир и има лек естествен блясък, който придава по-елегантен вид на
        спалното бельо.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Ластикът позволява чаршафът да приляга добре към матрака и да остава стабилно на място по
        време на сън. Това прави чаршафите с ластик сатен удобни и практични за ежедневна употреба.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        За да създадете цялостен комплект спално бельо, можете да комбинирате чаршафите и с:
      </Typography>
      <Box sx={{ mb: 2, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/spalno-belio/plikove-za-zavivka/1/4/1"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          пликове за завивки памучен сатен
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/spalno-belio/kalufki/1/2/1"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          калъфки за възглавници памучен сатен
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/spalno-belio/charshafi/1/1/1"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          чаршафи без ластик памучен сатен
        </Typography>
      </Box>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        Ако предпочитате по-класическа памучна материя, можете да разгледате и:
      </Typography>
      <Box sx={{ mb: 4, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/spalno-belio/charshafi-s-lastik/1/3/2"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          чаршафи с ластик ранфорс
        </Typography>
      </Box>

      <Collapse in={expanded} collapsedSize={0}>
        {/* H2: Чаршафи с ластик памучен сатен за различни размери матраци */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Чаршафи с ластик памучен сатен за различни размери матраци
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Предлагаме чаршафи с ластик от памучен сатен за различни размери матраци, например:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            '80/200 (80х200) см',
            '90/200 (90х200) см',
            '100/200 (100х200) см',
            '120/200 (120х200) см',
            '140/200 (140х200) см',
            '160/200 (160х200) см',
            '180/200 (180х200) см',
            '200/200 (200х200) см',
            '220/200 (220х200) см'
          ].map((size) => (
            <Typography key={size} variant="body1" sx={{ color: 'text.secondary' }}>
              {size}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Чаршафите могат да бъдат изработени и за нестандартни размери матраци, което е особено
          удобно при легла със специфични размери или при матраци с топ матрак.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Благодарение на индивидуалната изработка чаршафът приляга добре към матрака и остава
          стабилно на място. Това прави чаршафите с ластик от памучен сатен подходящи както за
          стандартни легла, така и за нестандартни размери матраци.
        </Typography>

        {/* H2: Чаршафи с ластик памучен сатен за високи матраци */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Чаршафи с ластик памучен сатен за високи матраци
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Чаршафите с ластик от памучен сатен могат да бъдат изработени и за по-високи матраци, като
          при поръчка се избира подходящият диапазон на височината.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Това позволява чаршафът да обхване добре матрака и да остане стабилно на място по време на
          сън.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Чаршафите са подходящи за:
        </Typography>
        <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0, mb: 4 }}>
          <li>стандартни матраци</li>
          <li>по-високи ортопедични матраци</li>
          <li>матраци с топ матрак</li>
          <li>легла тип боксспринг (boxspring)</li>
        </Box>

        {/* H2: Популярни търсения */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Популярни търсения при чаршафите с ластик от памучен сатен
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Клиентите често търсят чаршафи с ластик от памучен сатен по размер на матрака или според
          вида на леглото. Сред най-често търсените варианти са:
        </Typography>
        <Box sx={{ mb: 4, pl: 2 }}>
          {[
            'чаршаф с ластик памучен сатен 90/200',
            'чаршаф с ластик памучен сатен 120/200',
            'чаршаф с ластик памучен сатен 140/200',
            'чаршаф с ластик памучен сатен 160/200',
            'чаршаф с ластик памучен сатен 180/200',
            'чаршаф с ластик памучен сатен за висок матрак',
            'чаршаф с ластик памучен сатен за нестандартен матрак'
          ].map((item) => (
            <Typography key={item} variant="body1" sx={{ color: 'text.secondary' }}>
              {item}
            </Typography>
          ))}
        </Box>
      </Collapse>
      <Button
        onClick={() => setExpanded(!expanded)}
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          mb: 3,
          '&:hover': { backgroundColor: 'rgba(212, 175, 55, 0.08)' }
        }}>
        {expanded ? 'Скрий' : 'Прочетете повече'}
      </Button>

      {/* H2: ЧЗВ */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 3 }}>
        Често задавани въпроси за чаршафи с ластик памучен сатен
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Какво представлява памучният сатен?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Памучният сатен е памучна материя, изработена чрез специален начин на тъкане, който
            прави плата по-гладък и фин на допир. Той има лек естествен блясък и придава
            по-елегантен вид на спалното бельо.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящи ли са чаршафите с ластик от памучен сатен за ежедневно използване?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Памучният сатен е естествен памучен плат, който е дишащ и комфортен за сън.
            Чаршафите с ластик от памучен сатен са подходящи както за ежедневно използване, така и
            за хора, които предпочитат по-гладка и фина текстура на спалното бельо.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            За какви размери матраци могат да се изработят чаршафи с ластик от памучен сатен?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Чаршафите могат да бъдат изработени за различни размери матраци. При поръчка е
            необходимо да посочите ширината, дължината и височината на матрака, за да може чаршафът
            да бъде изработен така, че да пасва добре.
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Това позволява изработка както за стандартни, така и за нестандартни размери.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящи ли са чаршафите с ластик от памучен сатен за високи матраци?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Чаршафите могат да бъдат изработени и за по-високи матраци, като при поръчка се
            избира подходящият диапазон на височината.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Свива ли се памучният сатен при пране?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Както всички памучни материи, памучният сатен може да има естествена свиваемост около
            4–5% при пране. При изработката се предвижда необходимият запас, така че чаршафът да
            пасва добре на матрака и след пране.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            За колко време се изработват чаршафите?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Чаршафите се изработват по индивидуални параметри според избраните размери на матрака.
            Обичайният срок за изработка е между 3 и 10 работни дни, като в повечето случаи
            поръчките са готови в рамките на 4–7 работни дни.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
